// In antd 5, component theming is handled via ConfigProvider tokens in Root.
// This function updates CSS custom properties for any custom styles that use them.
const updateTheme = (theme) => {
  if (!theme) return;
  const root = document.documentElement;
  Object.entries(theme).forEach(([key, value]) => {
    if (key.startsWith('@')) {
      root.style.setProperty('--' + key.slice(1), value);
    }
  });
};

export default updateTheme;

